import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ChevronRightIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M4,1.4 C4,1.42915853 6.1,3.46249186 10.3,7.5 L4,14 L5.4,15.4 L13.1,7.4 L5.4,0 C4.46666667,0.904174805 4,1.37084147 4,1.4 Z"
        data-testid="icon-chevronRight"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
